export const GET_GROUP_TIMELINE_SUCCESS = 'GET_GROUP_TIMELINE_SUCCESS';
export const SET_FETCHING_GROUP_TIMELINE = 'SET_FETCHING_GROUP_TIMELINE';